export default {"src":"https://fishbrain.com/_next/static/media/iowa.cbf332bc.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};